"use client";

import { LanguageContext } from "@/context/languageContext";
import styles from "@/styles/modules/components/homepage/module1.module.scss";
import { HomepageOptions } from "@/types/wordpress";
import Link from "next/link";
import { useContext, useEffect, useState } from "react";

interface Module1Props {
  homepageOptions: HomepageOptions;
}

export default function Module1({ homepageOptions }: Module1Props) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en" ? homepageOptions.module1 : homepageOptions.module1DE
  );

  useEffect(() => {
    setData(
      language === "en" ? homepageOptions.module1 : homepageOptions.module1DE
    );
  }, [homepageOptions.module1, homepageOptions.module1DE, language]);

  if (
    language === "en" &&
    !homepageOptions.module1.optionsHomepageModule1.text &&
    !homepageOptions.module1.optionsHomepageModule1.link
  )
    return null;

  if (
    language === "de" &&
    !homepageOptions.module1DE.optionsHomepageModule1.text &&
    !homepageOptions.module1DE.optionsHomepageModule1.link
  )
    return null;

  return (
    <section
      className={styles.module1}
      style={{
        backgroundColor: data.backgroundColor.backgroundColor || "",
      }}
    >
      <div className={styles.module1Container} data-aos="fade-in">
        {data.optionsHomepageModule1.text && (
          <p
            dangerouslySetInnerHTML={{
              __html: data.optionsHomepageModule1.text,
            }}
          />
        )}

        <Link
          href={data.optionsHomepageModule1.link.url}
          target={data.optionsHomepageModule1.link.target}
        >
          {data.optionsHomepageModule1.link.title}
        </Link>
      </div>
    </section>
  );
}
